module.exports = __webpack_public_path__ + "img/vehicle.89e710c6.svg";